<template>
<section class="item_box">
    <!-- 免费券 -->
    <section :class="['coupon_item',item.couponType == 2?'price_coupon':'',item.couponType == 4?'discount_coupon':'',item.couponType == 3?'time_coupon':'',come == 'linting'&&!item.available || (come != 'linting' && item.detailStatus != '2')?'cantClick':'']" @click="itemClick(item)">
        <section class="item_left">
            <span class="left_tips">{{item.couponType|couponType}}</span>
            <p v-if="item.couponType == 1"><span>1</span>次</p>
            <p v-else-if="item.couponType == 2"><span>{{item.freeAmount}}</span>元</p>
            <p v-if="item.couponType == 4"><span>{{item.freeAmount | discountT(1)}}</span><i>.{{item.freeAmount | discountT(2)}}</i>折</p>
            <p v-if="item.couponType == 3"><span>{{item.freeAmount}}</span>分钟</p>
            <section class="dashed"></section>
        </section>
        <section class="item_right">
            <h2>{{item.couponName}}</h2>
            <p>领券时间: {{item.bindTime}}</p>
            <!-- 使用条件 -->
            <p v-if="item.couponType == 3">使用条件: {{item.isFreeTime == 1?'享受车场免费时长,':'不享受车场免费时长,'}}停车费{{item.minFee}}元-{{item.maxFee}}元使用</p>
            <p v-else-if="item.timeUseNumber">使用条件:每满{{item.timeUseStandard}}分钟可使用{{item.timeUseNumber}}张</p>
            <p v-else-if="item.maxFee">使用条件: 停车费{{item.minFee}}元-{{item.maxFee}}元使用</p>
            <p v-if="item.validityUnit == 1">有效期: 领券后{{item.couponValidityTime}}分钟有效</p>
            <p v-else-if="item.validityUnit == 2">有效期: 领券后{{item.couponValidityTime}}小时有效</p>
            <p v-else-if="item.validityUnit == 3">有效期: 领券后{{item.couponValidityTime}}天有效</p>
        </section>
        <template v-if="come != 'linting'">
        <span v-if="item.detailStatus == 2" class="useBtn">去使用</span>
        <img v-else-if="item.detailStatus == 3" class="status_img" src="../../../assets/images/icon_ticket_used.png" />
        <img v-else-if="item.detailStatus == 4" class="status_img" src="../../../assets/images/icon_ticket_expired.png" />
        </template>
        <template v-if="come == 'linting'">
            <span v-if="!selected" class="un_selected"></span>
            <img v-else class="selected" src="../../../assets/images/icon_check_0.png" />
        </template>
    </section>
</section>
</template>
<script>
export default {
  props: {
    type: {
      type:String,
      default:'0'
    },
    item: {
      type:Object,
      default:()=>{}
    },
    come:{
        type:String,
        default:''
    },
    selected:{
        type:Boolean,
        default:false
    },
    canClick:{
        type:Boolean,
        default:true
    },
  },
  filters:{
      couponType(val){
      if(val == 1){
        return '免费券'
      }else if(val == 2){
        return '金额券'
      }else if(val == 3){
        return '时间券'
      }else{
        return '折扣券'
      }
    },
    discountT(val,type){
        let num = (val/10).toFixed(1).toString();
        if(type == 1){
            return num.split(".")[0]
        }else{
            return num.split(".")[1]
        }
    }
  },
  data () {
    return {
    }
  },
  methods: {
      itemClick(item){
        if(this.come == 'linting'){
            if(!item.available){return;}
            this.$emit("itemClick",item)
        }else{
            this.$emit("itemClick",item)
        }
      }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.coupon_item{
    // margin:0 40px 40px;
    // overflow:hidden;
    .flex();
    height:240px;
    position: relative;
    // box-shadow:0px 12px 20px 0px rgba(220,231,226,1);
    &:last-child{
        margin-bottom: 20px;
    }
    .useBtn{
        position: absolute;
        right:28px;
        top:28px;
        width:128px;
        height:52px;
        background:rgba(255,255,255,1);
        border-radius:4px;
        text-align: center;
        line-height: 52px;
        color:#333;
        font-size:26px;
    }
    .un_selected{
        position: absolute;
        right:28px;
        top:50%;
        margin-top:-18px;
        width:36px;
        height:36px;
        border-radius:100%;
        background:rgba(255,255,255,1);
        border:1px solid rgba(218,218,218,1);
    }
    .status_img{
        position: absolute;
        right:24px;
        top:50%;
        margin-top:-60px;
        width:120px;
        height:120px;
    }
    .selected{
        position: absolute;
        right:28px;
        top:50%;
        margin-top:-18px;
        width:36px;
        height:36px;
        border-radius:100%;
    }
    .item_left{
        overflow: hidden;
        width:220px;
        background:rgba(231,248,242,1);
        border-radius:16px;
        .flex();
        justify-content: center;
        align-items: center;
        position: relative;
        .left_tips{
            display:block;
            width:100px;
            height:44px;
            background:rgba(199,239,225,1);
            border-radius:16px 0px 16px 0px;
            line-height: 44px;
            text-align: center;
            position: absolute;
            top:0;left:0;
            font-size:24px;
            color:rgba(22,188,132,1);
        }
        p{
            font-size:28px;
            color:rgba(22,188,132,1);
            line-height:40px;
            span{
                font-size:60px;
                // font-weight:bold;
                color:rgba(22,188,132,1);
                line-height:84px;
            }
        }
        .dashed{
            position: absolute;
            right:0;top:20px;
            width:2px;
            height:200px;
            border-right:2px dashed rgba(0,0,0,0.1);
        }
    }
    .item_right{
        flex:1;
        height:240px;
        background:rgba(243,251,249,1);
        border-radius:16px;
        .flex(column);
        justify-content: center;
        h2{
            font-size:30px;
            color:rgba(51,51,51,1);
            line-height:42px;
            margin-bottom:30px;
            margin-left:40px;
        }
        p{
            font-size:24px;
            color:rgba(51,51,51,0.5);
            line-height:34px;
            margin-bottom:4px;
            margin-left:40px;
            width: 80%;
        }
        .right_btns{
            // height:68px;
            position: relative;
            .flex();
            margin-left:30px;
            .btn{
                width:204px;
                // height:68px;
                height: 92px;
                background:url('../../../assets/images/background_y.png') left top no-repeat;
                background-size:204px 92px;
                // box-shadow:0px 8px 12px 0px rgba(233,204,182,1);
                border-radius:34px 4px 4px 34px;
                text-align: center;
                line-height: 76px;
                font-size:28px;
                color:rgba(255,255,255,1);
            }
            .btn_right{
                background:url('../../../assets/images/background_blue.png') left top no-repeat;
                background-size:204px 92px;
                // box-shadow:0px 8px 12px 0px rgba(164,195,222,1);
                border-radius:4px 34px 34px 4px;
            }
            .line{
                position: absolute;
                left:182px;top:0;
                height:78px;
                width:20px;
                background:rgba(243,251,249,1);
                transform: rotate(15deg)
            }
        }
    }
    .last_num{
        position: absolute;
        top:-22px;right:-12px;
        width:120px;
        height:44px;
        background:rgba(252,63,86,1);
        border-radius:22px 22px 22px 0px;
        font-size:22px;
        color:rgba(255,255,255,1);
        line-height:40px;
        text-align: center;
        span{
            font-size:30px;
        }
    }
}
.price_coupon{
    // box-shadow:0px 12px 20px 0px rgba(231,226,220,1);
    .item_left{
        background:rgba(255,245,229,1);
        .left_tips{
            background:rgba(255,230,191,1);
            color:rgba(255,155,0,1);
        }
        p{
            color:rgba(255,155,0,1);
            span{
                color:rgba(255,155,0,1);
            }
        }
    }
    .item_right{
        background:rgba(255,250,242,1);
    }
}
.discount_coupon{
    // box-shadow:0px 12px 20px 0px rgba(235,220,222,1);
    .item_left{
        background:rgba(254,235,238,1);
        .left_tips{
            background:rgba(254,214,219,1);
            color:rgba(252,63,86,1);
        }
        p{
            color:rgba(252,63,86,1);
            span{
                color:rgba(252,63,86,1);
                vertical-align: -2px;
            }
            i{
                font-size:36px;
                font-style: normal;
                vertical-align: -2px;
            }
        }
    }
    .item_right{
        background:rgba(255,245,246,1);
    }
}
.time_coupon{
    // box-shadow:0px 12px 20px 0px rgba(210,221,231,1);
    .item_left{
        background:rgba(234,245,255,1);
        .left_tips{
            background:rgba(0,135,255,0.16);
            color:rgba(0,135,255,1);
        }
        p{
            color:rgba(0,135,255,1);
            span{
                color:rgba(0,135,255,1);
            }
        }
    }
    .item_right{
        background:rgba(242,249,255,1);
    }
}
.cantClick{
    .item_left{
        background:#f4f4f4;
        .left_tips{
            background:#E6E6E6;
            color:#999;
        }
        p{
            color:#999;
            span{
                color:#999;
            }
        }
    }
    .item_right{
        background:#f4f4f4;
        h2{
            color:#999;
        }
        p{
            color:#999;
        }
    }
}
</style>
